import React from 'react';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import { NavTabs } from '@fuww/library/src/Tabs';
import Tab from '../Tab';
import messages from '../../lib/messages.json';

const Tabs = () => {
  const { query, route: currentRoute } = useRouter();
  const marketId = Number(query.marketId);
  const intl = useIntl();

  return (
    <NavTabs
      value={currentRoute}
      NavTab={Tab}
      tabs={[
        {
          route: 'market',
          params: { marketId },
          value: '/market',
          label: intl.formatMessage(messages.home),
        },
        {
          route: 'market-brands',
          value: '/market-brands',
          params: { marketId },
          label: intl.formatMessage(messages.brands),
        },
        {
          route: 'products',
          value: '/products',
          params: { marketId },
          label: intl.formatMessage(messages.products),
        },
      ]}
    />
  );
};

export default Tabs;
